import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { useQueryPromocao } from 'pages/revendedor/promocao/hooks';
import { PromocaoRevendedor } from 'pages/revendedor/promocao/types';
import { brlDate } from 'util/format';

const getRows = (data: PromocaoRevendedor[] | undefined): GridRowsProp => {
    if (Array.isArray(data) && data.length) {
        return data.map((item) => ({
            id: item.idPromocaoRevendedor,
            idPromocaoRevendedor: item.idPromocaoRevendedor,
            dsPromocaoRevendedor: item.dsPromocaoRevendedor,
            dhInicioPromocao: item.dhInicioPromocao,
            dhFimPromocao: item.dhFimPromocao,
        }));
    }

    return [];
};

export function PromocaoGrid() {
    const { data, refetch, isFetching } = useQueryPromocao();

    const columns: GridColDef[] = [
        { field: 'idPromocaoRevendedor', headerName: 'Código', width: 100 },
        { field: 'dsPromocaoRevendedor', headerName: 'Descrição', flex: 1 },
        {
            field: 'dhInicioPromocao',
            headerName: 'Data de início',
            align: 'center',
            headerAlign: 'center',
            width: 120,
            valueFormatter: (value) => brlDate(value),
        },
        {
            field: 'dhFimPromocao',
            headerName: 'Data de fim',
            align: 'center',
            headerAlign: 'center',
            width: 120,
            valueFormatter: (value) => brlDate(value),
        },
    ];

    return (
        <Block>
            <PanelGrid
                hasNext={data?.hasNext}
                rows={getRows(data?.data)}
                rowsCount={data?.total ?? 0}
                reload={refetch}
                loading={isFetching}
                columns={columns}
            />
        </Block>
    );
}
